/* global gsap, ScrollTrigger */

document.addEventListener('DOMContentLoaded', initHeaderBehavior);

document.addEventListener('shopify:section:load', initHeaderBehavior);

let headerResizeBound = false;
let headerResizeRaf = null;

function updateHeaderHeights() {
  const announcement = document.querySelector('.mount-announcement-bar');
  const header = document.querySelector('.mount-header');
  const main = document.querySelector('main');

  if (!announcement || !header || !main) return;

  const announceHeight = announcement.offsetHeight;
  const headerHeight = header.offsetHeight;
  const totalHeight = announceHeight + headerHeight;

  document.documentElement.style.setProperty('--announcement-height', `${announceHeight}px`);
  document.documentElement.style.setProperty('--header-total-height', `${totalHeight}px`);

  main.style.paddingTop = `${totalHeight}px`;
}

function initHeaderBehavior() {
  gsap.registerPlugin(ScrollTrigger);

  const announcement = document.querySelector('.mount-announcement-bar');
  const header = document.querySelector('.mount-header');
  const main = document.querySelector('main');
  const allSections = document.querySelectorAll('main .shopify-section');
  const firstSection = allSections[1];

  if (!announcement || !header || !main) return;

  updateHeaderHeights();

  const isTopPage = document.body.classList.contains('template-index');

  if (isTopPage && firstSection) {
    // ScrollTrigger.killAll();
    // ScrollTrigger.create({
    //   trigger: firstSection,
    //   start: "top top",
    //   onEnter: () => header.classList.add("js-active"),
    //   onLeaveBack: () => header.classList.remove("js-active"),
    // });
    header.classList.add('js-active');
  } else {
    header.classList.add('js-active');
  }

  if (!headerResizeBound) {
    window.addEventListener('resize', () => {
      if (headerResizeRaf) cancelAnimationFrame(headerResizeRaf);
      headerResizeRaf = requestAnimationFrame(updateHeaderHeights);
    });
    headerResizeBound = true;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  (function () {
    const setUpAccordion = () => {
      const details = document.querySelectorAll('.js-details');
      const IS_OPENED_CLASS = 'is-opened';

      details.forEach((element) => {
        const summary = element.querySelector('.js-summary');
        const content = element.querySelector('.js-content');

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (element.classList.contains(IS_OPENED_CLASS)) {
            element.classList.toggle(IS_OPENED_CLASS);
            closingAnim(content, element).restart();
          } else {
            element.classList.toggle(IS_OPENED_CLASS);
            element.setAttribute('open', 'true');
            openingAnim(content).restart();
          }
        });
      });
    };

    const closingAnim = (content, element) =>
      gsap.to(content, {
        height: 0,
        opacity: 0,
        duration: 0.4,
        ease: 'power3.out',
        overwrite: true,
        onComplete: () => {
          element.removeAttribute('open');
        },
      });

    const openingAnim = (content) =>
      gsap.fromTo(
        content,
        {
          height: 0,
          opacity: 0,
        },
        {
          height: 'auto',
          opacity: 1,
          duration: 0.4,
          ease: 'power3.out',
          overwrite: true,
        }
      );

    // 初期化
    setUpAccordion();
  })();
});

/* ==================================================
  最下部で追従ボタンを非表示
  - Shopify Inbox
  - フィルターボタン
================================================== */
document.addEventListener('DOMContentLoaded', initBottomHideElements);
document.addEventListener('shopify:section:load', initBottomHideElements);

function initBottomHideElements() {
  const TARGET_SELECTORS = ['#shopify-chat'];

  const BOTTOM_THRESHOLD = 120;

  let ticking = false;

  const getTargets = () => {
    const elements = [];
    TARGET_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        elements.push(el);
      });
    });
    return elements;
  };

  const isBottomReached = () => {
    const scrollTop = window.scrollY || window.pageYOffset;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    return scrollTop + windowHeight >= documentHeight - BOTTOM_THRESHOLD;
  };

  const updateVisibility = () => {
    const targets = getTargets();
    if (!targets.length) return;

    const hide = isBottomReached();

    targets.forEach((el) => {
      el.style.transition = 'opacity 0.3s ease';

      if (hide) {
        el.style.opacity = '0';
        el.style.pointerEvents = 'none';
        el.style.visibility = 'hidden';
      } else {
        el.style.opacity = '1';
        el.style.pointerEvents = 'auto';
        el.style.visibility = 'visible';
      }
    });
  };

  const requestUpdate = () => {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(() => {
      updateVisibility();
      ticking = false;
    });
  };

  // イベント登録（重複防止）
  if (!window.__bottomHideBound) {
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate);
    window.__bottomHideBound = true;
  }

  // Shopify Inboxなど後からDOM追加される要素対応
  if (!window.__bottomHideObserverBound) {
    const observer = new MutationObserver(() => {
      requestUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.__bottomHideObserverBound = true;
  }

  // 初回実行
  requestUpdate();
}
